import type { Game, Room } from '../../types/game'
import { buildMobileLogEntries } from './mobileLogEntries'

interface MobileChatPreviewProps {
  room: Room
  game: Game
  memberId: string
  activePanel: string | null
  onOpenChat: () => void
}

export function MobileChatPreview({
  room,
  game,
  memberId,
  activePanel,
  onOpenChat,
}: MobileChatPreviewProps) {
  const messages = buildMobileLogEntries(room, game, memberId).slice(-3)

  return (
    <div
      id="mobile-chat-preview"
      className={`mobile-chat-preview${activePanel === 'chat' ? ' hidden' : ''}`}
    >
      <div id="mobile-chat-preview-messages" className="mobile-chat-preview-messages">
        {messages.map((entry) => (
          <div
            key={`mobile-chat-preview-${entry.timestamp.toISOString()}-${entry.kind}`}
            className="mobile-chat-preview-message"
          >
            <span
              className="mobile-chat-preview-sender"
              style={entry.kind === 'chat' && entry.color ? { color: `var(--${entry.color})` } : undefined}
            >
              {entry.kind === 'game' ? 'Game:' : `${entry.sender}:`}
            </span>
            <span>{entry.text}</span>
          </div>
        ))}
      </div>
      <button type="button" id="mobile-open-chat" className="mobile-chat-toggle lobby-start" onClick={onOpenChat}>
        Open Chat
      </button>
    </div>
  )
}
